import Vue from 'vue'
import Router from 'vue-router'
import ChatPage from "@/views/Apage/index"
var href =  window.location.pathname;
var liveids = href.replace(/\//g,'')
// console.log(liveids,'---===---')


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: `/${liveids}/`,//部署的子路径
  routes: [
    {
      path: '/',
      name: 'ChatPage',
      component: ChatPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js